import { render, staticRenderFns } from "./CollectionSettingModal.vue?vue&type=template&id=3aff212f&scoped=true&"
import script from "./CollectionSettingModal.vue?vue&type=script&lang=js&"
export * from "./CollectionSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff212f",
  null
  
)

export default component.exports